import { useTranslation } from 'react-i18next';
import { Form, useForm } from "@repo/ui/components/form";
import { TextField } from '@repo/ui/components/text-field';
import { TextAreaField } from "@repo/ui/components/area-field";
import { Button } from '@repo/ui/components/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@repo/ui/components/dialog';
import { z } from "zod/v4";
import { zodResolver } from "@hookform/resolvers/zod";
import { clientCallAPI } from "~/services/clientCallAPI";
import { Alert, AlertDescription } from '@repo/ui/components/alert';
import { useEffect, useRef, useState } from 'react';
import { CircleCheckBig } from '@repo/ui/components/icon';
import SectionChild from '~/components/SectionChild';
import { fetchJobIdBySlug } from '~/services/job';


function FormRecruitment() {
  const { t } = useTranslation("home");
  const schema = z.object({
    name: z.string(t('error.required', { ns: 'common' }) as string).min(1, t('error.required', { ns: 'common' }) as string).max(100, t('error.max', { ns: 'common', max: 100 }) as string),
    phone: z.string(t('error.required', { ns: 'common' }) as string).min(1, t('error.required', { ns: 'common' }) as string).max(11, t('error.max', { ns: 'common', max: 11 }) as string).regex(/^0\d{2}(-?\d{3})(-?\d{4})$/, t('error.invalid_phone', { ns: 'common' }) as string),
    email: z.email(t('error.invalid_email', { ns: 'common' }) as string),
  });
  const form = useForm({ resolver: zodResolver(schema), defaultValues: { name: '', phone: '', email: '' }, mode: 'onChange' });
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const [successMsg, setSuccessMsg] = useState<string | null>(null);
  const [successOpen, setSuccessOpen] = useState(false);
  const jobIdRef = useRef<string | null>(null);

  const [otpOpen, setOtpOpen] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const [tempData, setTempData] = useState<{ name: string; phone: string; email: string } | null>(null);
  const [resendLoading, setResendLoading] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [resendSuccess, setResendSuccess] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    }
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [countdown]);

  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? '0' : ''}${s}`;
  };

  const handleSendOtp = async (email: string, phone: string) => {
    try {
      await clientCallAPI("/api/otp/email/register-collborator", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, phone }),
      });
      setCountdown(300);
    } catch (error: any) {
      console.error("Lỗi gửi OTP:", error);
      throw error;
    }
  };

  const handleVerifyOtp = async () => {
    if (!tempData || !otpValue) return;
    setErrorMsg(null);
    setIsVerifyingOtp(true);
    try {
      const res = await clientCallAPI("/api/otp/email/collaborator/verify", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          phone: tempData.phone,
          fullName: tempData.name,
          email: tempData.email,
          otp: otpValue,
        }),
      });
      setOtpOpen(false);
      setSuccessMsg(`
Tên đăng nhập: ${res.username}, 
Mật khẩu tạm: ${res.tempPassword}, 
Vui lòng đăng nhập và đổi mật khẩu ngay sau khi đăng nhập.`
      );
      setSuccessOpen(true);
      form.reset();
      setOtpValue("");
      setCountdown(0);
    } catch (e) {
      setErrorMsg("Mã OTP không đúng hoặc đã hết hạn. Vui lòng thử lại.");
    } finally {
      setIsVerifyingOtp(false);
    }
  };

  const handleResendOtp = async () => {
    if (!tempData) return;
    setResendLoading(true);
    setErrorMsg(null);
    setResendSuccess(false);
    try {
      await clientCallAPI("/api/otp/email/collaborator/resend-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ Email: tempData.email }),
      });
      setResendSuccess(true);
      setCountdown(300);
      setTimeout(() => setResendSuccess(false), 3000);
    } catch (e) {
      setErrorMsg("Không thể gửi lại mã OTP. Vui lòng thử lại sau.");
    } finally {
      setResendLoading(false);
    }
  };


  return (
    <div className="bg-[url('/image/landing_page/background/form.jpg')] bg-cover bg-center bg-no-repeat min-h-[323px]">
      <div className="bg-grad-form">
        <SectionChild className="pb-5">
          <div className="pt-[50px] md:pt-[200px] max-w-[900px] mx-auto ">
            <div className="overflow-hidden bg-white/80 rounded-3xl">
              <div className="backdrop-blur-[80px] shadow-[0px_4px_20px_0px_#00666433]">
                <div className="px-4 lg:px-10 pt-10 pb-[36px] ">
                  <div className="">
                    <h3 className="pb-8 text-primary text-[30px] text-center font-helve">
                      Trở thành Cộng tác viên Kland <br /> Thu nhập không giới
                      hạn
                    </h3>
                    <Form {...form}>
                      <form
                        className="grid gap-5 md:grid-cols-3"
                        id="form-recruitment"
                        onSubmit={form.handleSubmit(async (data) => {
                          setErrorMsg(null);
                          try {
                            // let jobId = jobIdRef.current;
                            // if (!jobId) {
                            //   jobId = await fetchJobIdBySlug("cong-tac-vien");
                            //   jobIdRef.current = jobId;
                            // }
                            // const res = await clientCallAPI("/api/hiring-application", {
                            //   method: "POST",
                            //   headers: { "Content-Type": "application/json" },
                            //   body: JSON.stringify({
                            //     name: data.name,
                            //     phone: data.phone,
                            //     email: data.email,
                            //     jobId,
                            //   }),
                            // });
                            //  setSuccessMsg(
                            //   t(
                            //     "recruitment_section.messages.success"
                            //   ) as string
                            // );
                            // setSuccessOpen(true);

                            setTempData({ name: data.name, phone: data.phone, email: data.email });
                            await handleSendOtp(data.email, data.phone);
                            setOtpOpen(true);
                            form.reset();
                          } catch (e) {
                            setErrorMsg(
                              t("recruitment_section.messages.error") as string
                            );
                          }
                        })}
                      >
                        <input
                          type="hidden"
                          name="formType"
                          value="recruitment"
                        />
                        <div className="md:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-4">
                          {/* Fullname - full width */}
                          <div className="md:col-span-2">
                            <TextField
                              name="name"
                              placeholder={t("recruitment_section.form.fields.full_name.label")}
                              variant="outlined"
                            />
                          </div>

                          {/* Phone */}
                          <TextField
                            name="phone"
                            placeholder={t("recruitment_section.form.fields.phone.label")}
                            variant="outlined"
                          />

                          {/* Email */}
                          <TextField
                            name="email"
                            placeholder={t("recruitment_section.form.fields.email.label")}
                            variant="outlined"
                          />
                        </div>
                        <div className="flex flex-col items-center justify-center gap-5 mt-8 md:justify-between md:items-end md:flex-row md:col-span-3">
                          <div className="space-y-4 text-sm">
                            <div className="font-medium">Kland cam kết</div>
                            <ul className="space-y-2">
                              <li className="flex gap-2">
                                <CircleCheckBig className="text-primary" /> Hoàn
                                toàn miễn phí – không phát sinh chi phí
                              </li>
                              <li className="flex gap-2">
                                <CircleCheckBig className="text-primary" />
                                Thông tin cá nhân được giữ kín tuyệt đối
                              </li>
                              <li className="flex gap-2">
                                <CircleCheckBig className="text-primary" />
                                Chuyên viên liên hệ tư vấn nhanh trong vòng 24
                                giờ
                              </li>
                            </ul>
                          </div>
                          <Button
                            type="submit"
                            className="w-[228px] min-h-12"
                            loading={form.formState.isSubmitting}
                          >
                            {t("recruitment_section.form.submit")}
                          </Button>
                        </div>

                        {/* Modal Nhập OTP */}
                        <Dialog open={otpOpen} onOpenChange={setOtpOpen}>
                          <DialogContent className="max-w-md">
                            <DialogHeader>
                              <DialogTitle>Xác thực mã OTP</DialogTitle>
                            </DialogHeader>
                            <div className="space-y-4 py-4">
                              <div className="text-center space-y-2">
                                <p className="text-sm text-gray-600">
                                  Vui lòng nhập mã OTP đã được gửi đến email <strong>{tempData?.email}</strong>
                                </p>
                                {countdown > 0 ? (
                                  <p className="text-primary font-medium text-sm">
                                    Mã hiệu lực trong: {formatTime(countdown)}
                                  </p>
                                ) : (
                                  <p className="text-red-500 text-sm font-medium">Mã đã hết hạn</p>
                                )}
                              </div>
                              <input
                                type="text"
                                className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary h-12 text-center text-xl tracking-[0.5em] font-bold"
                                maxLength={6}
                                placeholder="------"
                                value={otpValue}
                                onChange={(e) => setOtpValue(e.target.value)}
                              />
                              {errorMsg && (
                                <p className="text-sm text-center text-red-500">{errorMsg}</p>
                              )}
                              {resendSuccess && (
                                <p className="text-sm text-center text-green-600 font-medium italic">Đã gửi lại mã OTP thành công!</p>
                              )}
                              <div className="flex flex-col gap-2">
                                <Button
                                  onClick={handleVerifyOtp}
                                  disabled={otpValue.length < 4 || countdown === 0}
                                  className="w-full"
                                >
                                  {isVerifyingOtp ? "Đang xác nhận..." : "Xác nhận"}
                                </Button>
                                <div className="text-center">
                                  <button
                                    type="button"
                                    onClick={handleResendOtp}
                                    disabled={resendLoading || (countdown > 0 && countdown > 240)} // Chờ 1p mới cho gửi lại
                                    className="text-sm text-primary hover:underline font-medium disabled:opacity-50"
                                  >
                                    {resendLoading ? "Đang gửi..." : "Gửi lại mã OTP"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </DialogContent>
                        </Dialog>


                        {successMsg ? (
                          <Dialog
                            open={successOpen}
                            onOpenChange={(v) => {
                              setSuccessOpen(v);
                              if (!v) {
                                setSuccessMsg(null);
                                form.reset();
                              }
                            }}
                          >
                            <DialogContent className="max-w-md">
                              <DialogHeader>
                                <DialogTitle>Thông báo</DialogTitle>
                              </DialogHeader>
                              <Alert className="border-0 bg-primary-50 text-primary">
                                <AlertDescription>
                                  {successMsg}
                                </AlertDescription>
                              </Alert>
                              <div className="flex justify-end">
                                <Button onClick={() => setSuccessOpen(false)}>
                                  Đóng
                                </Button>
                              </div>
                            </DialogContent>
                          </Dialog>
                        ) : null}
                        {errorMsg ? (
                          <div className="md:col-span-3">
                            <Alert variant="destructive">
                              <AlertDescription>{errorMsg}</AlertDescription>
                            </Alert>
                          </div>
                        ) : null}
                      </form>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SectionChild>
      </div>
    </div>
  );
}
export default FormRecruitment;
